import React from "react";

const About = () => {
    return (
        <div className="mt-3" id="About">
            <h1 className="text-center text-4xl font-bold font-serif">
                SIU ICT FAST 2K23
            </h1>
            <h1 className="text-center text-xl font-bold font-serif mt-2">
                Date: 5 March 2K23
            </h1>
            <p className="text-start p-9 text-lg">
                CSE Society of Sylhet International University organizes SIU ICT FAST
                every year. There are some events to improve the skills of students like
                ICT quizzes, programming competitions, hackathons, and project
                showcasing. This year CSE Society of Sylhet International University
                will organize arranged SIu Ict fast 2k23. We hope it will help our
                students to build bright careers and develop their skills. We believe
                that this event well is successful this year And this kind of event is
                very important for the students. Now Bangladesh is trying to make
                digitalization so we need more and more of this type of activity and we
                need more skills and manpower in the ICT field. Our Opening Ceremony
                will start on 5 march 2k23. Our program Inaugurate will The head of our
                CSE department Mr. MAG Asif Sir. Also present will be teachers of the
                CSE department Mr. Umar Faruk Jahangir, Farzana Akhtar, Abdullah Rajib,
                and Rajshree Roy Sir.The ICT quiz will start on 5 march at 2k23 at 10
                a.m. our prize giving ceremony will start on 7 march at 10 AM . In prize
                giving ceremony there chief guest is our honorable V.C Prof. Dr. Md.
                Shahid Ullah SIr and there Also present will be Our honorable chairman
                Rajib sir and our treasurer Nitai condo sir
            </p>
        </div>
    );
};

export default About;
